import RequestPage from "./RequestPage";

const ExternalHallam = () => {
 return (
        <RequestPage title="External Retreat Hallam"
            fetchUrl="/get-external-retreat-hallam-requests"
            editEndpoint="edit-external-retreat-hallam-request"
            deleteEndpoint="external-retreat-hallam-request"
            statusEndpoint="external-retreat-hallam-request" />
    );
}

export default ExternalHallam;